import { useAddToolCalibrationMutation } from "@common/api/tools"
import { handleError } from "@common/utils"
import { createFileRoute } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import {
  ActionCard,
  useCloseTo,
} from "@/routes/_layout/tools/-components/action-card"
import {
  CalibrationEntryFields,
  useCalibrationDraft,
} from "@/routes/_layout/tools/-components/calibration-entry"

export const Route = createFileRoute(
  "/_layout/tools/$toolId/calibrations/record",
)({
  component: RecordCalibration,
})

function RecordCalibration(): React.ReactElement {
  const { toolId } = Route.useParams()
  const showToast = useCustomToast()
  const mutation = useAddToolCalibrationMutation()
  const { draft, update } = useCalibrationDraft()
  const close = useCloseTo()

  const record = () =>
    mutation.mutate(
      {
        tool_id: toolId,
        toolCalibrationCreate: {
          kind: "record",
          performed_by: draft.performedBy.trim(),
          performed_on: draft.performedOn,
          result: draft.result,
          certificate_number: draft.certificateNumber.trim() || null,
          certificate_document_id: draft.certificate?.id ?? null,
        },
      },
      {
        onSuccess: () => {
          showToast("Recorded", "Calibration entry added.", "success")
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ActionCard
      title="Add calibration entry"
      confirmLabel="Add entry"
      ready={Boolean(draft.performedOn && draft.performedBy.trim())}
      pending={mutation.isPending}
      onCancel={close}
      onConfirm={record}
    >
      <CalibrationEntryFields draft={draft} update={update} withPerformer />
    </ActionCard>
  )
}
